import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { TrialPopupType } from '../analytics/types';

type PopupState = {
  type: TrialPopupType | null;
  callBack: (() => void) | null;
  onClose: (() => void) | null;
  source?: string;
};

type Store = {
  paywallPopupState: PopupState;
};

type Actions = {
  setPaywallPopupState: (newState: PopupState) => void;
  resetPaywallPopup: () => void;
};

const defaultState: Store = {
  paywallPopupState: {
    type: null,
    callBack: null,
    onClose: null,
  },
};

export const usePaywallPopup = create<Store & Actions>()(
  immer((set, get) => ({
    ...defaultState,
    setPaywallPopupState: (newState) => {
      set((state) => {
        state.paywallPopupState = newState;
      });
    },
    resetPaywallPopup: () => {
      set((state) => {
        get().paywallPopupState?.onClose?.();
        state.paywallPopupState = defaultState.paywallPopupState;
      });
    },
  })),
);
